module.exports = __webpack_public_path__ + "img/foot.e14995ed.png";